/* Header disclosure behavior only. Product configuration and commerce are untouched. */
(() => {
  const initialize = root => {
    if (root.classList.contains('kn-ready')) return;
    const menus = [...root.querySelectorAll('[data-kn-menu]')];
    const mobile = menus.find(menu => menu.dataset.knMenu === 'mobile');
    const hover = window.matchMedia('(min-width: 1361px) and (hover: hover) and (pointer: fine)');
    const desktop = window.matchMedia('(min-width: 1361px)');
    let closeTimer, locked = false, previousOverflow = '';
    const update = () => {
      const open = menus.find(menu => menu.open);
      root.dataset.knOpen = open?.dataset.knMenu || '';
      if (mobile?.open && !locked) {
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        locked = true;
      } else if (!mobile?.open && locked) {
        document.documentElement.style.overflow = previousOverflow;
        locked = false;
      }
    };
    const close = (returnFocus = false) => {
      window.clearTimeout(closeTimer);
      const open = menus.find(menu => menu.open);
      menus.forEach(menu => { menu.open = false; delete menu.dataset.knReason; });
      update();
      if (returnFocus) open?.querySelector('summary')?.focus();
    };
    menus.forEach(menu => {
      menu.addEventListener('toggle', () => {
        if (menu.open) menus.forEach(other => {
          if (other !== menu) { other.open = false; delete other.dataset.knReason; }
        });
        update();
      });
      if (menu === mobile) return;
      const category = menu.closest('[data-kn-category-item]');
      (category || menu).addEventListener('pointerenter', () => {
        if (!hover.matches) return;
        window.clearTimeout(closeTimer);
        menus.forEach(other => { if (other !== menu) other.open = false; });
        menu.dataset.knReason = 'hover';
        menu.open = true;
        update();
      });
      category?.querySelector('.kn-category-link')?.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        window.clearTimeout(closeTimer);
        menus.forEach(other => { if (other !== menu) other.open = false; });
        menu.open = true;
        update();
        menu.querySelector('.kn-mega-panel a[href]')?.focus();
      });
      menu.querySelector('summary')?.addEventListener('click', event => {
        // Moving to the arrow can open the panel before the pointer click reaches it.
        // Keep that first click open; the category link remains a separate native link.
        if (hover.matches && event.detail > 0 && menu.open && menu.dataset.knReason === 'hover') {
          event.preventDefault();
          menu.dataset.knReason = 'click';
        }
      });
    });
    root.addEventListener('pointerenter', () => window.clearTimeout(closeTimer));
    root.addEventListener('pointerleave', () => {
      if (hover.matches && !root.contains(document.activeElement)) closeTimer = window.setTimeout(() => close(), 160);
    });
    root.addEventListener('click', event => {
      const target = event.target.closest?.('[data-kn-close], a[href]');
      if (target?.hasAttribute('data-kn-close')) close(true);
      else if (target?.matches('a[href]')) close();
    });
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const nested = event.target.closest?.('.kn-mobile-collection[open]') || event.target.closest?.('[data-kn-category-item]')?.querySelector('.kn-mobile-collection[open]');
      if (nested && mobile?.open) {
        nested.open = false;
        nested.querySelector('summary')?.focus();
      } else close(true);
      event.preventDefault();
    });
    document.addEventListener('pointerdown', event => {
      if (!root.contains(event.target)) close();
    });
    document.addEventListener('focusin', event => {
      if (!root.contains(event.target)) close();
    });
    desktop.addEventListener('change', () => close());
    root.classList.add('kn-ready');
    update();
  };
  const start = () => document.querySelectorAll('[data-kalia-visual-header]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll?.('[data-kalia-visual-header]').forEach(initialize);
  });
})();
